<!--components/app/AppBar-->
<template>
    <v-app-bar app dense>

        <v-app-bar-nav-icon @click="$emit('open-hamburger')"></v-app-bar-nav-icon>

        <v-toolbar-title>
            <a :href="homepage">
                <v-img width="150" height="40" class="justify-left" contain src="/img/maxcarelogo.svg"></v-img>
            </a>
        </v-toolbar-title>

        <v-tabs ref="tabs" v-model="selectedTab" optional align-with-title class="d-none d-md-flex">
            <v-tab v-for="m in menu"
                   v-show="m !== loginMenuItem || !showLoginButton"
                   :to="m.to"
                   :href="m.href"
                   :key="m.title">{{ m.title }}</v-tab>
        </v-tabs>

        <v-spacer></v-spacer>

        <!-- This was for internal member portal management -->
        <!--<template v-if="isLoggedIn">
            <div>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-avatar color="primary"
                                  class="white--text cursor-pointer text-uppercase"
                                  v-bind="attrs"
                                  v-on="on"
                                  size="36">
                            <span>{{ getInitials(displayName) }}</span>
                        </v-avatar>
                    </template>

                    <span class="ml-2">{{ displayName }}</span>
                </v-tooltip>
            </div>

            <v-menu offset-x left open-on-hover>
                <template v-slot:activator="{ on }">
                    <v-btn small icon v-on="on" class="ml-2">
                        <v-icon small color="secondary">fas fa-ellipsis-v</v-icon>
                    </v-btn>
                </template>

                <v-list flat dense class="py-0">
                    <v-list-item v-if="isAdmin" @click="masquerade.show = true">
                        <v-list-item-icon class="justify-center">
                            <v-icon dense color="primary">fas fa-mask</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Masquerade</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="signOut">
                        <v-list-item-icon class="justify-center">
                            <v-icon dense color="primary">fas fa-sign-out-alt</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Sign Out</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-menu>
        </template>-->

        <!--<template v-else-if="showLoginButton">-->
            <v-btn color="primary" outlined :href="loginMenuItem.href">{{ loginMenuItem.title }}</v-btn>
        <!--</template>-->

        <v-dialog v-if="isAdmin" v-model="masquerade.show" persistent scrollable max-width="600">
            <v-card>
                <v-card-title>
                    <span class="text-h5">View as Member</span>
                </v-card-title>

                <v-card-text>
                    <v-autocomplete v-model="masquerade.selected"
                                    :items="masqueradeItems"
                                    :search-input.sync="masquerade.searchText"
                                    :loading="masquerade.loading"
                                    :item-text="getMemberDisplay"
                                    placeholder="None (Type to Search)"
                                    clearable
                                    no-filter
                                    return-object></v-autocomplete>
                </v-card-text>

                <v-card-actions>
                    <v-btn @click="masquerade.show = false">
                        Close
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="setMasquerade()">
                        Revert View
                    </v-btn>
                    <v-btn color="primary" @click="setMasquerade(masquerade.selected)">
                        Change View
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-app-bar>
</template>

<script>
	import AppMixin from '@/mixins/app'
	import BlockUiMixin from '@/mixins/blockUI'
	import MessageHandlerMixin from '@/mixins/messageHandler'
	import RouteMixin from '@/mixins/route'
	import UserMixin from '@/mixins/user'
	import UserSettingsMixin from '@/mixins/userSettings'
	import UtilityMixin from '@/mixins/utility'

    import { Api, Role } from '@/utility/constants'

	export default {
		props: {
            displayName: String,
            menu: Array,
            homepage: String
		},

		mixins: [
			AppMixin,
			BlockUiMixin,
			MessageHandlerMixin,
			RouteMixin,
			UserMixin,
			UserSettingsMixin,
			UtilityMixin
        ],

        data() {
            return {
                selectedTab: null,
                masquerade: {
                    show: false,
                    selected: null,
                    members: [],
                    searchText: null,
                    loading: false
                }
            }
        },
    
        computed: {
            loginMenuItem() {
                return this.menu.filter(x => x.isLogin)[0]
            },

            onLoggedInPage() {
                return this.loginMenuItem != null && this.$route.matched.some(x => x.path === this.loginMenuItem.to)
            },

            showLoginButton() {
                return !this.isLoggedIn && !this.onLoggedInPage
            },

            isLoggedIn() {
                return this.getUserId !== 0
            },

            isAdmin() {
                return (this.getUserRoles || []).includes(Role.ADMIN)
            },

            masqueradeItems() {
                if (this.masquerade.selected != null && !this.masquerade.members.includes(this.masquerade.selected)) {
                    return [this.masquerade.selected].concat(this.masquerade.members)
                }
                return this.masquerade.members
            }
        },

        watch: {
            selectedTab(newVal) {
                this.$emit("input", this.menu.filter(x => x.to === newVal)[0])
            },

            "masquerade.searchText"(newVal) {
                this.masquerade.loading = true;
                this.$http({
                    url: Api.MEMBER.SEARCH_MEMBERS,
                    method: Api.METHOD.POST,
                    data: {
                        value: newVal
                    }
                }).then(response => {
                    this.masquerade.members = response.data
                }).catch(error => {
                    console.log(error)
                    if (error && error.response.status !== 401) {
                        this.showMessage('error', 'Unable to search at this time: ' + error.response.statusText)
                    }
                }).finally(() => {
                    this.masquerade.loading = false
                })
            },

            "masquerade.show"(newVal) {
                if (newVal) {
                    this.showBlockUI();
                    this.$http({
                        url: Api.MEMBER.GET_MASQUERADE,
                        method: Api.METHOD.GET
                    }).then(response => {
                        if (response.data) {
                            this.masquerade.selected = response.data
                        }
                    }).catch(error => {
                        console.log(error)
                        if (error && error.response.status !== 401) {
                            this.showMessage('error', 'Unable to resolve current setting: ' + error.response.statusText)
                        }
                    }).finally(() => {
                        this.hideBlockUI();
                    })
                }
            }
        },

        methods: {
			signOut() {
				if (this.getBlockUIShow) return;

				this.showBlockUI()

				this.$http({
					url: Api.AUTH.SIGN_OUT,
					method: Api.METHOD.POST
				}).then(response => {
					let resp = response.data

					this.hideBlockUI()

					if (resp.success) {
						window.location.href = resp.message
					} else {
						this.showMessage('error', resp.errorMessage);
					}
				}).catch(error => {
					this.hideBlockUI()
					console.log(error)
					if (error && error.response.status !== 401) {
						this.showMessage('error', 'Unable to Sign Out at this time: ' + error.response.statusText)
					}
				})
            },

            getMemberDisplay(member) {
                return `${member.displayName} (${member.memberId}${member.personCode})`
            },

            setMasquerade(member) {
                this.showBlockUI();

                let url = member != null ? Api.MEMBER.MASQUERADE : Api.MEMBER.CLEAR_MASQUERADE

                this.$http({
                    url: url,
                    method: Api.METHOD.POST,
                    data: member
                }).then(response => {
                    let resp = response.data
                    if (!resp.success) {
                        this.showMessage('error', resp.errorMessage)
                    } else {
                        this.$router.go()
                    }
                }).catch(error => {
                    console.log(error)
                    if (error && error.response.status !== 401) {
                        this.showMessage('error', 'Unable to change view at this time: ' + error.response.statusText)
                    }
                }).finally(() => {
                    this.hideBlockUI();
                })
            }
        }
	}
</script>